import { render, staticRenderFns } from "./AddEditSubEventSponsorInvitationDetails.vue?vue&type=template&id=79263c0f"
import script from "./AddEditSubEventSponsorInvitationDetails.vue?vue&type=script&lang=js"
export * from "./AddEditSubEventSponsorInvitationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports